import React from 'react';
import LiteYouTubeEmbed from "react-lite-youtube-embed"
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css"

function Winner(props) {
  return (
    <div className="p-5 max-w-xl m-auto p-6 bg-white border border-gray-200 rounded-lg shadow">
      {props.content.videoId && <LiteYouTubeEmbed id={props.content.videoId} width='100%' />}
      {props.content.loomCode && <div dangerouslySetInnerHTML={{ __html: props.content.loomCode}}/>}
      {props.content.videoUrl && <video src={props.content.videoUrl} controls/>}
      <a href={props.content.moreinfo} target="_blank" rel="noopener noreferrer">
        <div className="flex mt-4 justify-between">
          <div>
            <h5 className="mb-2 mt-2 text-2xl font-bold tracking-tight text-gray-900">
              {props.content.title} by {props.content.author}
            </h5>
          </div>
        </div>
      </a>
      <p className="mb-5 mt-5 font-normal text-gray-700">
        {props.content.desc}
      </p>

      <div className="mb-5">
        {props.content.prize.map((element, index) => (
          <p key={index}>{element === 'Top 3 finalist' ? '🏆' : '🏅'} {element}</p>
        ))}
      </div>
      {props.content.moreinfo &&
        <a href={props.content.moreinfo} target="_blank" rel="noopener noreferrer" className="inline-flex items-center py-2 text-sm font-medium text-center text-black bg-white rounded-lg focus:outline-none">
          View project
          <svg aria-hidden="true" className="w-4 h-4 ml-2 -mr-1" fill="#FF630B" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </a>
      }
    </div>
  );
}

export default Winner;
